<template>
    <div class="talk_parent_1">
        <div class="talk_div_1">{{text}}</div>
        <div class="triangle_border_left_1"></div>
    </div>
</template>

<script>
export default {
  props:["text"],
  data() {
    return {
      testNums: 0,
    };
  }
};
</script>


<style lang="scss" scoped>
.talk_parent_1 {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  margin-right: 10px;
}
.ai_head_img2_1 {
  width: 52px;
  height: 52px;
  margin-right: 6px;
}
.talk_div_1 {
  min-width: 20px;
  background: #e1eeeb;
  border-radius: 4px;
  padding-left: 11px;
  padding-right: 11px;
  padding-top: 14px;
  padding-bottom: 14px;
  margin-left: 10px;
  font-size: 14px;
  color: #343434;
}
/*向左*/
.triangle_border_left_1 {
  width: 0;
  height: 0;
  border-width: 6px 9px 6px 0;
  border-style: solid;
  margin-top: 15px;
  border-color: transparent transparent #e1eeeb transparent; /*透明 灰 透明 透明 */
  position: relative;
}
</style>